import React from 'react';
import {
  Button,
  Confirm,
  Header,
  Dropdown,
  Form,
  Icon,
} from 'semantic-ui-react';
import Messages from '../Messages';
import { languages } from '../../constants';
import PermissionsManager from '../PermissionsManager';
import { inlineStyle } from '../../styles/custom';

const MenuLinkForm = ({
  status,
  categories,
  obj,
  onChange,
  onSubmit,
  onDelete,
  isHeaderMenu = false,
}) => {
  const renderCategories = (categories, locale) => {
    const filteredCategories = categories.filter(
      (category) => category.language_code === locale,
    );

    return !filteredCategories.length
      ? [{ value: null, text: '--' }]
      : filteredCategories.map((category) => ({
          value: category.id,
          text: category.name,
        }));
  };

  return (
    <Form>
      <Header>
        Lien ({isHeaderMenu ? 'Header' : ' Footer'}) :{' '}
        {status.isNew ? 'Création' : 'Édition'}
      </Header>

      {status.error ? <Messages errors={status.errors} /> : null}
      <Form.Field>
        <label>Selectionnez une langue</label>
        <Dropdown
          fluid
          selection
          closeOnChange
          id="language_code"
          placeholder="Langue"
          value={obj.language_code}
          options={languages.map((language) => ({
            value: language.code,
            text: language.label,
          }))}
          onChange={(event, data) => onChange(event, data, 'dropdown')}
        />
      </Form.Field>
      {isHeaderMenu &&
        (categories.loading ? (
          <div>Chargement des catégories...</div>
        ) : (
          <Form.Field>
            <label>Selectionnez une catégorie (obligatoire)</label>
            <Dropdown
              fluid
              selection
              closeOnChange
              id="menu_category_id"
              placeholder="Catégorie"
              value={obj.menu_category_id}
              required
              options={renderCategories(
                categories.getMenuCategories,
                obj.language_code,
              )}
              onChange={(event, data) => onChange(event, data, 'dropdown')}
            />
          </Form.Field>
        ))}
      <Form.Field>
        <Form.Input
          label="Ordre"
          type="number"
          placeholder="Ordre"
          id="order"
          value={obj.order}
          onChange={onChange}
        />
      </Form.Field>
      <Form.Group widths="equal">
        <Form.Input
          placeholder="Label"
          id="label"
          fluid
          label="Label du lien"
          value={obj.label}
          onChange={onChange}
        />
        <Form.Input
          placeholder="URL"
          id="url"
          fluid
          label="Lien ciblé"
          value={obj.url}
          onChange={onChange}
        />
      </Form.Group>
      <br />
      <br />
      <Form.Field>
        <PermissionsManager hasPermissions={['update_menu']}>
          {status.loading ? (
            <Button type="submit" floated="left" color="red" loading>
              {' '}
              Chargement...
            </Button>
          ) : (
            <Button
              type="submit"
              floated="left"
              color="olive"
              onClick={onSubmit}
            >
              <Icon name="save" /> Sauvegarder
            </Button>
          )}
        </PermissionsManager>
        <PermissionsManager hasPermissions={['update_menu']}>
          {!status.isNew ? (
            <div>
              <Button
                type="submit"
                color="red"
                floated="right"
                onClick={(service, data) => {
                  onDelete(service, { confirm: true });
                }}
              >
                <Icon name="delete" /> Suppression
              </Button>
            </div>
          ) : null}
        </PermissionsManager>
      </Form.Field>
      <Confirm
        content="Êtes-vous sûr(e) de vouloir supprimer ce service ? Cette action est définitive."
        open={status.deletion.confirm}
        onCancel={(category, data) => {
          onDelete(category, { confirm: null });
        }}
        onConfirm={(category, data) => {
          onDelete(category, { confirm: false });
        }}
        style={inlineStyle.modal}
        cancelButton="Annuler"
        confirmButton="Ok"
      />
    </Form>
  );
};

export default MenuLinkForm;



// WEBPACK FOOTER //
// ./src/components/form/MenuLink.js